export default __webpack_public_path__ + "static/media/thumnail.76e1d64e.svg";